// extracted by mini-css-extract-plugin
module.exports = {"overlay":"FollowingOverlay_overlay__lPxlW","box":"FollowingOverlay_box__ORyed","button":"FollowingOverlay_button__zS_wn"};